import type { DeleteMeterResponse } from '@vy/api-definition';
import { DeleteMeterResponseSchema } from '@vy/api-definition';
import type { WeftApi } from '@vy/client';
import { useMutation, useQueryClient, type UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../../services/api';
import {
  invalidateMetersQueries,
  invalidateProductsQueries,
} from '../../utils/query-invalidation';

export type DeleteMeterRequest = Parameters<WeftApi['deleteMeter']>[0];

export function useDeleteMeter(
  options?: UseMutationOptions<DeleteMeterResponse, unknown, DeleteMeterRequest>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ meterId }) => {
      const api = getPrivateApi();
      const deleteMeterResponse = await api.deleteMeter({ meterId });

      return DeleteMeterResponseSchema.parse(deleteMeterResponse);
    },
    onSuccess: async () => {
      await Promise.all([
        invalidateMetersQueries(queryClient),
        invalidateProductsQueries(queryClient),
      ]);
    },
    ...options,
  });
}
